import createApp from './app.js'

import authService from './service.auth.js'
import firestoreService from './service.firestore.js'
import storageService from './service.storage.js'
import functionsService from './service.functions.js'
import performanceService from './service.performance.js'
import analyticsService from './service.analytics.js'

const appConfig = {"apiKey":"AIzaSyBkv8cRgOpvPHaHi5v-BsFtgPzS3oG0itw","authDomain":"rainbow-care.firebaseapp.com","databaseURL":"https:\u002F\u002Frainbow-care.firebaseio.com","projectId":"rainbow-care","storageBucket":"rainbow-care.appspot.com","messagingSenderId":"163837344667","appId":"1:163837344667:web:99b9ace163344cd9","measurementId":"G-34HQDQJVSY","fcmPublicVapidKey":"BESPy3r-QUJrc_qjnSyJcR_i5wphy6nB79Gcx5uCWYHkvz5dT05seo6xZuKsckDpuH9saKj6QIL2jGE1ddHleN4"}

export default async (ctx, inject) => {
  /****************************************
  **************** LAZY MODE **************
  ****************************************/

  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.server) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
    firestoreService(session, firebase, ctx, inject),
    storageService(session, firebase, ctx, inject),
    functionsService(session, firebase, ctx, inject),

    ]
  }

  if (process.client) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
      firestoreService(session, firebase, ctx, inject),
      storageService(session, firebase, ctx, inject),
      functionsService(session, firebase, ctx, inject),
      performanceService(session, firebase, ctx, inject),
      analyticsService(session, firebase, ctx, inject),

    ]
  }

  const [
    auth,
    firestore,
    storage,
    functions,
    performance,
    analytics
  ] = await Promise.all(servicePromises)

  const fire = {
    auth: auth,
    firestore: firestore,
    storage: storage,
    functions: functions,
    performance: performance,
    analytics: analytics
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}
